<div id="user-settings-account" class="settings-panel" [class.mobile]="isMobile">
  <form [formGroup]="form" (submit)="submitChanges()" class="settings-panel-form">
    <div class="head">
      <span class="material-icons go-back" (click)="goBack.emit()"> arrow_back </span>
      <div class="description">
        <div class="title">{{ PANELS.ACCOUNT.name }}</div>
        <div class="subtitle">{{ PANELS.ACCOUNT.description }}</div>
      </div>
      <span class="material-icons close" (click)="goBack.emit()"> close </span>
    </div>
    <div class="sub-head" *ngIf="isMobile">
      {{ PANELS.ACCOUNT.description }}
    </div>
    <div class="body">
      <div class="image-upload-wrap" [ngClass]="{ noImage: !form.value.profile_image }">
        <div class="image-placeholder" *ngIf="!form.value.profile_image">
          <app-profile-photo
            [user]="user"
            [width]="160"
            [fontSize]="36"
            [isClickEnabled]="false"
          ></app-profile-photo>
        </div>
        <div *ngIf="form.value.profile_image" class="image-upload-img">
          <img [src]="form.value.profile_image" alt="" />
        </div>
        <div
          class="upload-btn"
          (click)="file.value = ''; file.click()"
          *ngIf="!isUploadingImage"
          [ngClass]="{ disabled: detailsEditDisabled }"
          [appTooltip]="'Students cannot change their picture in this institution.' | translate"
          [appTooltipPlacement]="'center-end'"
          [appTooltipCreateNewLine]="true"
          [appTooltipMaxWidth]="200"
          [appTooltipDisabled]="!detailsEditDisabled"
          [appTooltipArrow]="'left'"
        >
          <span class="material-icons"> edit </span>
        </div>
        <input
          type="file"
          accept="image/*"
          #file
          class="d-none"
          (change)="upload($event)"
          [disabled]="detailsEditDisabled"
        />
      </div>
      <div class="fields">
        <div class="form-field">
          <div class="value">
            <label for="user-name">{{ 'FULL NAME' | translate }}</label>
            <input
              id="user-name"
              formControlName="name"
              autocomplete="off"
              [appTooltip]="'Students cannot change their name in this institution.' | translate"
              [appTooltipPlacement]="'center-end'"
              [appTooltipMaxWidth]="200"
              [appTooltipCreateNewLine]="true"
              [appTooltipDisabled]="!detailsEditDisabled"
              [appTooltipArrow]="'left'"
            />
          </div>
          <div class="error" *ngIf="form.controls.name.invalid">
            <div
              class="message"
              *ngIf="form.controls.name.errors?.required || form.controls.name.errors?.whitespace"
            >
              {{ 'Name is required' | translate }}
            </div>
            <div class="message" *ngIf="form.controls.name.errors?.maxlength">
              {{ "Name should not exceed {{maxLength}} characters" | translate: {maxLength:
              MAX_ENTITY_TITLE_LENGTH} }}
            </div>
          </div>
        </div>
        <div class="form-field phone-field" *ngIf="hasSMSReminderCapability$ | async">
          <div class="value phone-input-wrapper">
            <label for="user-phone">{{ 'PHONE NUMBER' | translate }}</label>
            <ngx-mat-intl-tel-input
              #phoneInput
              [attr.id]="'user-phone'"
              [cssClass]="'phone-input'"
              [enableSearch]="true"
              [searchPlaceholder]="'Search' | translate"
              [format]="'national'"
              (paste)="onPhonePaste($event)"
              (focusin)="isPhoneFocused = true"
              (focusout)="isPhoneFocused = false"
              formControlName="phone"
            ></ngx-mat-intl-tel-input>
            <div
              class="error"
              *ngIf="form.controls.phone.touched && form.controls.phone.invalid && !isPhoneFocused"
            >
              {{ 'Phone number is invalid' | translate }}
            </div>
          </div>
        </div>
        <ng-container *ngIf="infoForm" formGroupName="info">
          <div class="form-field">
            <div class="value">
              <label for="role-type">
                {{ "What's your role?" | translate }}
              </label>
              <div class="role-selection-container">
                <app-radio-group-input
                  [options]="roleOptions"
                  [selectedOption]="selectedRoleOption"
                  (selectionChange)="setRoleValue($event)"
                ></app-radio-group-input>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="delete-account-section">
        <app-pencil-button
          class="pencil-button"
          theme="tertiary-link"
          data-name="user-settings-delete-account"
          (clickEvent)="deleteAccount()"
          [buttonType]="'button'"
          [label]="'Delete my account' | translate"
        >
        </app-pencil-button>
      </div>
    </div>
    <div class="foot" [class.show]="formChanged$ | async">
      <app-pencil-button class="pencil-button btn-ok" [disabled]="form.invalid">
        <span *ngIf="!isLoading" class="material-icons">check</span>
        <mat-spinner *ngIf="isLoading" [diameter]="16" color="#FFF"></mat-spinner>
        <span>{{ 'Update' | translate }}</span>
      </app-pencil-button>
      <app-pencil-button
        class="pencil-button btn-cancel"
        (click)="resetForm()"
        [buttonType]="'button'"
        icon="close"
        [iconConfig]="{ type: 'material-icon' }"
        [label]="'Cancel' | translate"
      >
      </app-pencil-button>
    </div>
  </form>
</div>
